<div *ngIf="loading$ | async" class="spinner">
  <!-- <mat-spinner></mat-spinner> -->
</div>

<h1 class="table__title">Business Owners</h1>

<ul class="table__control inline-list">
  <li>
    <button mat-raised-button class="grey-btn" (click)="upload()">
      <mat-icon><img src="assets/images/icon-save.svg" /></mat-icon>
      Upload
    </button>
  </li>
  <li>
    <button mat-raised-button class="grey-btn" (click)="download()">
      <mat-icon><img src="assets/images/icon-download.svg" /></mat-icon>
      Download
    </button>
  </li>
  <li>
    <button mat-raised-button class="grey-btn" [routerLink]="['AddNew']">
      <mat-icon><img src="assets/images/icon-add.svg" /></mat-icon>
      Business Owner
    </button>
  </li>
  <li>
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search for business owner" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
  </li>
</ul>

<div class="table__container">
  <ng-container *ngIf="!(businessOwners?.length > 0)">
    <h3>No Business Owners</h3>
  </ng-container>


  <table class="table__inner" mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="active">
      <th mat-header-cell mat-sort-header *matHeaderCellDef align="center">
        Active
      </th>
      <td mat-cell *matCellDef="let element" align="left">

        <mat-icon><img [src]="element?.active ? 'assets/images/icon-valid.svg' : 'assets/images/icon-invalid.svg'" />
        </mat-icon>

      </td>
    </ng-container>

    <ng-container matColumnDef="fullname">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element"><a [routerLink]="[element.id]">
          {{ element?.fullname }}</a></td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Email
      </th>
      <td mat-cell *matCellDef="let element">{{ element?.email }}</td>
    </ng-container>

    <ng-container matColumnDef="department">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Department
      </th>
      <td mat-cell *matCellDef="let element">{{ element?.department }}</td>
    </ng-container>

    <ng-container matColumnDef="designation">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Designation
      </th>
      <td mat-cell *matCellDef="let element">{{ element?.designation }}</td>
    </ng-container>

    <ng-container matColumnDef="telephone">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Telephone
      </th>
      <td mat-cell *matCellDef="let element">{{ element?.telephone }}</td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

</div>
<mat-paginator class="table__pagination" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
